import { details } from "./details";
import { list } from "./list";
import { menu } from "./menu";

export const basket = {
    namespaced: true,
    modules: {
        details,
        list,
        menu
    }
};



// WEBPACK FOOTER //
// ./src/store/basket/basket.js